module.exports = __webpack_public_path__ + "static/media/payment-option-cash-on-delivery.532a3787.svg";